export const protocolAbbreviations = {
  'AVX-20': 'avx',
  'BEP-20': 'bep',
  'ERC-20': 'erc',
  'HRC-20': 'hrc',
  'KRC-20': 'krc',
  Matic: 'plg',
  'FTM-20': 'ftm',
  HecoChain: 'hco',
  Base: 'base',
  UTXO: 'utxo',
  'Smart Chain': 'smartChain',
  Moonriver: 'mvr',
  Arbitrum: 'arb',
  'QRC-20': 'qrc',
  QTUM: 'qtum',
  'Ethereum Classic': 'etc',
  //  Optimism: "opt",
  Moonbeam: 'glmr',
  'RSK Smart Bitcoin': 'rsk',
  SmartBCH: 'sbch',
  Ubiq: 'ubiq',
  ZHTLC: 'zhtlc',
  SLP: 'slp',
  TENDERMINT: 'tendermint',
  TENDERMINTTOKEN: 'tenderminttoken',
  ETH: 'eth',
  EWT: 'ewt',
  SIA: 'sia',
};
